import { inject, Injectable, Signal } from '@angular/core';
import { AccountLanguageCode, UserProfileCompany } from '@app/shared/types/models/user/user-profile.model';
import { Observable } from 'rxjs';
import { OwnProfileLoadState, UsersDataService } from '../users-data.service';

/**
 * Thin facade so views never call {@link UsersDataService} profile/preferences methods directly.
 * Reuses {@link UsersDataService} rather than owning a second own-profile cache.
 */
@Injectable({ providedIn: 'root' })
export class UserProfileActionsService {
  private readonly usersDataService = inject(UsersDataService);

  public getOwnProfileCompanies(): Signal<UserProfileCompany[]> {
    return this.usersDataService.getOwnProfileCompanies();
  }

  public getAccountLanguage(): Signal<AccountLanguageCode | undefined> {
    return this.usersDataService.getAccountLanguage();
  }

  public getOwnProfileState(): Signal<OwnProfileLoadState> {
    return this.usersDataService.getOwnProfileState();
  }

  public isPreferencesSaving(): Signal<boolean> {
    return this.usersDataService.isPreferencesSaving();
  }

  public loadOwnProfile(): void {
    this.usersDataService.loadOwnProfile();
  }

  public refreshOwnProfile(): void {
    this.usersDataService.refreshOwnProfile();
  }

  public updateAccountLanguage(language: AccountLanguageCode): Observable<AccountLanguageCode> {
    return this.usersDataService.updateAccountLanguage(language);
  }
}
